import React from 'react';
import './FocusModeTag.css';

// The focus mode a conversation's last message ran in, on its row in the
// conversation lists (the sidebar's and a project's own) -- the API's
// `focus_mode`, null for General Focus. The label is the mode's job number
// when it has one ("3190"), else its name without "Focus" ("Proposals"); the
// full name is in the tooltip.
const FocusModeTag = ({ focusMode }) => {
  if (!focusMode?.name) return null;
  const label = focusMode.short || focusMode.name.replace(/\s+Focus$/i, '');
  return (
    <span className="chat-focus-mode-inline focus-mode-tag" title={`Focus mode: ${focusMode.name}`}>
      {label}
    </span>
  );
};

export default FocusModeTag;
